module.exports = "https://store.zigzag.kr/resources/arm64/20260318-1116-5adb0cbd42_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";